import { grey } from '@mui/material/colors';

export const FUND_VALUE_PROGRESSION_BAR_COLORS = {
  paidInCapital: grey[400],
  fundNav: '#FF4378',
  distributions: grey[900],
} as const;

export const FUND_VALUE_PROGRESSION_LEGEND_ITEMS = [
  {
    color: FUND_VALUE_PROGRESSION_BAR_COLORS.paidInCapital,
    label: 'Paid in capital',
  },
  {
    color: FUND_VALUE_PROGRESSION_BAR_COLORS.fundNav,
    label: 'Fund NAV',
  },
  {
    color: FUND_VALUE_PROGRESSION_BAR_COLORS.distributions,
    label: 'Distributions',
  },
];

export const MAX_FUND_VALUE_PROGRESSION_PERIODS = 10;
export const MIN_FUND_VALUE_PROGRESSION_PERIODS = 2;
export const PROGRESSION_BARS_PER_COLUMN = 3;
export const PROGRESSION_GAPS_PER_COLUMN = 2;

/** Densest layout (10 periods) on the narrowest screens. */
export const BAR_WIDTH_AT_MAX_PERIODS = 12;
export const BAR_GAP_AT_MAX_PERIODS = 4;
export const COLUMN_PADDING_AT_MAX_PERIODS = 10;

/** Sparsest layout (2 periods) on the narrowest screens. */
export const BAR_WIDTH_AT_MIN_PERIODS_NARROW = 32;
export const BAR_GAP_AT_MIN_PERIODS_NARROW = 8;
export const COLUMN_PADDING_AT_MIN_PERIODS_NARROW = 40;

/** Sparsest layout (2 periods) when the column slot is wide enough. */
export const BAR_WIDTH_AT_MIN_PERIODS_WIDE = 64;
export const BAR_GAP_AT_MIN_PERIODS_WIDE = 16;

/** PDF densest layout (10 periods); sparse periods scale from portal targets. */
export const PDF_BAR_WIDTH_AT_MAX_PERIODS = 6;
export const PDF_BAR_GAP_AT_MAX_PERIODS = 2.5;

export const MIN_PROGRESSION_BAR_HEIGHT_PX = 1;
export const AXIS_LABEL_FONT_SIZE = 12;
export const Y_AXIS_GRID_GAP = 16;
export const Y_AXIS_CHAR_WIDTH = 6.5;
export const Y_AXIS_PADDING = 4;
export const Y_AXIS_LABEL_EXTRA_WIDTH = 8;
export const CHART_HEIGHT = 440;
export const PDF_CHART_HEIGHT = 235;
export const CHART_TOP_MARGIN = 8;
export const X_AXIS_LABEL_GAP = 16;
export const X_AXIS_LABEL_FONT_SIZE = 12;
export const X_AXIS_LABEL_LINE_HEIGHT = 12;
export const X_AXIS_YEAR_QUARTER_GAP = 4;
export const X_AXIS_LABEL_BOTTOM_PADDING = 4;
export const X_AXIS_YEAR_FONT_WEIGHT = 500;
export const X_AXIS_QUARTER_FONT_WEIGHT = 400;
